import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="contact-info">
              <span>info@carmanya.com</span>
            </div>
            <div className="locations">
              <span>Mumbai | Navi Mumbai | Pune | Cochin | Kolkata | Vapi | Aurangabad | Hyderabad | Ahmedabad | Delhi | Kolhapur | Bengaluru | Jaipur | Raipur | Bhubaneswar</span>
            </div>
          </div>
        </div>
      </div>
      <nav className="navbar">
        <div className="container">
          <div className="nav-content">
            <Link to="/" className="logo">
              <h2>Carmanya</h2>
            </Link>
            <button className="mobile-menu-toggle" onClick={toggleMenu}>
              <span></span>
              <span></span>
              <span></span>
            </button>
            <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
              <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
              <li className="dropdown">
                <Link to="/research" onClick={() => setIsMenuOpen(false)}>Research</Link>
                <ul className="dropdown-menu">
                  <li><Link to="/research#newsletter">Monthly Newsletter</Link></li>
                  <li><Link to="/research#updates">Latest Updates</Link></li>
                  <li><Link to="/research#webinars">Webinars</Link></li>
                  <li><Link to="/research#case-law">Case Law</Link></li>
                  <li><Link to="/research#articles">Featured Articles</Link></li>
                </ul>
              </li>
              <li className="dropdown">
                <Link to="/services" onClick={() => setIsMenuOpen(false)}>Our Services</Link>
                <ul className="dropdown-menu">
                  <li><Link to="/services#company-law">Company Law Management Services</Link></li>
                  <li><Link to="/services#sebi">SEBI and Listing</Link></li>
                  <li><Link to="/services#forex">Foreign Exchange Management</Link></li>
                  <li><Link to="/services#mutual-funds">Services Provided to Mutual Funds</Link></li>
                  <li><Link to="/services#applications">Applications and Approvals</Link></li>
                  <li><Link to="/services#restructuring">Corporate Restructuring Services</Link></li>
                  <li><Link to="/services#legal">Legal Services</Link></li>
                  <li><Link to="/services#accounting">Accounting services</Link></li>
                  <li><Link to="/services#cfo">Virtual CFO</Link></li>
                  <li><Link to="/services#csr">CSR Advisory</Link></li>
                </ul>
              </li>
              <li><Link to="/about" onClick={() => setIsMenuOpen(false)}>About</Link></li>
              <li><Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact Us</Link></li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
